import React from 'react';
import StatusBanner from '../ui/StatusBanner';

/**
 * Thin compatibility wrapper around the generic StatusBanner primitive.
 * Prefer importing StatusBanner directly for new call sites.
 */
function DirectorPanelState({ kind = 'info', message, onRetry, retryLabel }) {
  return <StatusBanner kind={kind} message={message} onRetry={onRetry} retryLabel={retryLabel} />;
}

export default DirectorPanelState;
